import { UserUpdate } from '../../../types/user';
import { ApiAbstract } from '../abstract';

export class ApiUpdateUser extends ApiAbstract<UserUpdate, UserUpdate> {}
